import React, {  useMemo } from 'react';
import { Card,  } from 'antd';
import Title from 'components/Title';
import ModalControllerNV from 'components/ModalControllerNV';
import { useQuery } from 'react-query';
import { TpstatResponse, getTPCurrentStatusByTpid } from 'services/thirdParty';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import StatusModal from '../StatusCard/StatusModal';
export type CurrentStatusCardProps = {
  id: number;
  refetchProp: boolean;
  isActive?: boolean;
};
const CurrentStatusCard = ({refetchProp, id,isActive}: CurrentStatusCardProps) => {
  console.log("isActive",isActive);
  
  const { data,isFetching } = useQuery(
    ['getTPCurrentStatusByTpid', id,refetchProp],
    () =>
      getTPCurrentStatusByTpid({ tpid: id, type: '' }).then(
        (res) => res.list || []
      ),
    {enabled: isActive !== false}
  );
 

  const columns = useMemo<DataGridColDef<TpstatResponse>[]>(
    () => [
      {
        dataIndex: 'statustypelabel',
      },
      {
        dataIndex: 'statuslabel',
        render: (_value, _record, index) => (
          <ModalControllerNV
            content={({ setVisible, visible }) => (
              <a onClick={() => setVisible(true)}>
                 {_record.statuslabel ?? _record.status}
              </a>
              
            )}
            modal={({ setVisible, visible }) => (
              <StatusModal
                visible={visible}
                onClose={() => {
                  setVisible(false);
                }}
                params={{ tpid: Number(id), type: _record.statustype}}
                refetchProp={isFetching}
              />
            )}
          />
        ),
      },

  

      {
        dataIndex: 'startdate',

      
      },
      {
        dataIndex: 'enddate',

       
      },
      {
        dataIndex: 'statusdate',

       
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

          return (
            <Card
              title={<Title level={5} comcode="CurrentStatus" />}
              style={{
                width: '100%',
                boxShadow:
                  'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
                marginBottom: 10,
              }}
              bordered
            >
              <DataGrid
                rowKey="tpstatusid"
                dataSource={data}
                columns={columns}
              />
            </Card>
          );
     
};

export default CurrentStatusCard;
